<template>
  <div class="flex justify-center mt-2 mb-10 flex-col items-center">
    {{ queryForDisplay }}
  </div>
</template>

<script>
export default {
  name: 'Search',
  props: {
    query: {
      type: String,
      default: 'unknown'
    }
  },
  computed: {
    queryForDisplay() {
      return `Current query: ${this.query}`
    }
  }
}
</script>
